import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { AppDispatch, RootState } from "../stores/store";
import { notificationApi } from "../service/notification-service";

export const NotificationListener: React.FC = () => {
	const dispatch = useDispatch<AppDispatch>();
	const notifications = useSelector((state: RootState) => state.notifications.notifications);
	const prevLengthRef = useRef(notifications.length);

	useEffect(() => {
		if (notifications.length <= prevLengthRef.current) {
			prevLengthRef.current = notifications.length;
			return;
		}

		// Invalidate cache so next bell click fetches fresh count from server
		dispatch(notificationApi.util.invalidateTags(['Notifications']));
		prevLengthRef.current = notifications.length;

		// Show toast for the new notification
		const latestNotification = notifications[0];
		switch (latestNotification.type?.toLowerCase()) {
			case "success":
				toast.success(latestNotification.message, { position: "top-right", autoClose: 5000 });
				break;
			case "error":
				toast.error(latestNotification.message, { position: "top-right", autoClose: 7000 });
				break;
			case "warning":
				toast.warning(latestNotification.message, { position: "top-right", autoClose: 5000 });
				break;
			default:
				toast.info(latestNotification.message, { position: "top-right", autoClose: 5000 });
		}
	}, [notifications]);

	return null;
};
